import React from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { useTranslation } from 'react-i18next'

import { getCurrentAppData } from '../utils/fractalApps'
import { signIn, cleanAuth } from '../store/auth/actions'

import LoginComponent from '../components/form/LoginForm'
import AppLink from '../components/shared/AppLink'

import {
  container,
  linkContainer
} from './styles/LoginPage.style'
import { getParamsFromQueryString } from '../utils/url'

const LoginPage = ({ signIn, lang, cleanAuth }) => {
  const LinkButtonColor = getCurrentAppData() ? getCurrentAppData().theme.primaryColor : ''
  const { t } = useTranslation()

  React.useEffect(() => {
    cleanAuth()
  }, [])

  const versarAppIds = ['34', '42', '43', '46', '48', '49', '51', '57']
  const { app_id: appId } = getParamsFromQueryString()

  const isVersar = versarAppIds.includes(appId)

  return (
    <div className={container}>

      <LoginComponent lang={lang} translation={t} LinkButtonColor={LinkButtonColor} onSubmit={(data) => signIn({ data, translation: t })} />

      <div className={linkContainer}>
        {!isVersar && <AppLink
          to={'/signup'}
          color={LinkButtonColor}
        >
          {t('login')['createFractalIdLink']}
        </AppLink>}
        <AppLink
          color={LinkButtonColor}
          to={'/forgot-my-password'}>
          {t('login')['forgotPasswordLink']}
        </AppLink>
      </div>

    </div>
  )
}

LoginPage.propTypes = {
  signIn: PropTypes.func.isRequired,
  lang: PropTypes.string,
  cleanAuth: PropTypes.func
}

LoginPage.defaultProps = {
  loginValues: undefined
}

const mapStateToProps = (state) => ({
  lang: state.auth.lang
})

const mapDispatchToPros = dispatch =>
  bindActionCreators(
    {
      signIn,
      cleanAuth
    },
    dispatch
  )

export default connect(mapStateToProps, mapDispatchToPros)(LoginPage)
